module.exports = __webpack_public_path__ + "img/airplane.edfd5941.gif";